import React from 'react'
import { useHydrated } from 'react-hydrated'

export const IfHydrated = React.memo<{
	yes: () => React.ReactNode
	no?: () => React.ReactNode
}>(function IfHydrated(props) {
	const hydrated = useHydrated()

	return hydrated ? <>{props.yes()}</> : <>{props.no?.()}</>
})
